define(function (require) {
    "use strict";

    var template = require("manager-templates/data-sources/attributes/codePropertyItemView.tmpl");

    var CodePropertyItemView = {};

    LE.module('LEManager', function (LEManager, LE, Backbone, Marionette, $, _) {

        CodePropertyItemView = Marionette.ItemView.extend({

            template:template,
            tagName:'li',
            className:'scraper-item',



            //--------------------------------------------------
            // initialize
            //--------------------------------------------------

            initialize : function (options) {
                LEManager.logger.debug("CodePropertyItemView:initialize");
            },

            customTemplateHelpers: function() {
                var that = this;
                return {
                    propertyName: function(){
                        return that.model.getName();
                    }
                };
            },

            onClose: function(){
                LEManager.logger.debug("CodePropertyItemView:onClose");
            }

        });
    });

    return CodePropertyItemView;
});